import { render, staticRenderFns } from "./accueil-2.vue?vue&type=template&id=be986bd8&scoped=true&"
import script from "./accueil-2.vue?vue&type=script&lang=js&"
export * from "./accueil-2.vue?vue&type=script&lang=js&"
import style0 from "./accueil-2.vue?vue&type=style&index=0&id=be986bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be986bd8",
  null
  
)

export default component.exports